const CLUSTER_ENVIRONMENTS: Array<string | undefined> = ['production', 'staging', 'testing']

/**
 * Decide if we should emit "machine readable" logs (JSON format), or pretty printed logs, based on env vars
 */
export const machineReadableLogs = (): boolean => {
  if (process.env.MACHINE_READABLE_LOGS?.toLowerCase() === 'true') {
    return true
  }
  return CLUSTER_ENVIRONMENTS.includes(process.env.NODE_ENV)
}
